import { useParams } from "react-router-dom";
import { machines } from "../data/machines";

export default function MachineDetail() {
  const { id } = useParams();
  const machine = machines[id];

  if (!machine) return <p className="p-10">Machine not found</p>;

  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
     <img
  src={machine.image}
  alt={machine.title}
  className="w-full max-h-[400px] object-contain rounded-xl mb-6"
/>


      <h1 className="text-3xl font-bold mb-4">{machine.title}</h1>
      <p className="text-lg mb-6">{machine.desc}</p>
      <ul className="list-disc pl-6 text-gray-700 mb-6">
        {machine.specs.map((s, i) => (
          <li key={i}>{s}</li>
        ))}
      </ul>
      <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-500">
        Request a Quote
      </button>
    </div>
  );
}
